// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__TvLyg"};